export const options = [
  'All questions',
  'Correct questions',
  'Incorrect questions',
  'Missed questions',
];
